// Arrow (MOB-5). PURE (ENG-1). Spawns via the EntitySystem; the flight integrator
// + hit resolution run in EntitySystem.tickProjectiles (shared for every arrow).
import { PROJECTILE } from '../../config';
import type { Entity, EntitySystem, Projectile } from '../entity';
import { solveAim } from './shared';

/** Fire an arrow from mob `shooter` aimed at (tx,ty,tz) for `damage`. An optional
 *  `effect` makes it a tipped arrow (stray → slowness, M13.2). */
export function fireArrowAt(sys: EntitySystem, shooter: Entity, tx: number, ty: number, tz: number, damage: number, effect?: Projectile['effect']): void {
  const sx = shooter.x, sy = shooter.y + 1.3, sz = shooter.z; // from ~shoulder height
  const v = solveAim(tx - sx, ty - sy, tz - sz, PROJECTILE.ARROW_SPEED);
  sys.spawnProjectile('arrow', sx, sy, sz, v.x, v.y, v.z, shooter.id, damage, effect);
}
